module.exports = __webpack_public_path__ + "img/Brand_xl.bde7ea4d.png";